export default{
  timestampFunction: () => (new Date()).toISOString()
};
